module.exports = __webpack_public_path__ + "static/7-a50761133ad62e25ce632bafaa8fcc4b.png";